import React from 'react';
import ItemCard from '../ItemCard';

const StudyModeItemCard = ({ topic, isRevealed, onReveal, searchTerm }) => {
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isRevealed) {
      onReveal();
    }
  };

  return (
    <div 
      className={`relative ${!isRevealed ? 'cursor-pointer' : ''}`}
      onClick={handleClick}
    >
      <div className="relative" style={{ zIndex: 10 }}>
        <ItemCard 
          item={{
            ...topic,
            name: topic.name,
            tag: topic.tag,
            basket_id: isRevealed ? topic.basket_id : null,
            concepts: isRevealed ? topic.concepts : [],
            is_master: topic.is_master
          }}
          searchTerm={searchTerm}
          onClick={(e) => {
            if (!isRevealed) {
              e.preventDefault();
              e.stopPropagation();
              onReveal();
            }
          }}
          showTooltipInStudyMode={true}
        />
      </div>
      {!isRevealed && (
        <div 
          className="absolute inset-0" 
          style={{ zIndex: 20 }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onReveal();
          }}
        >
          {/* Concepts loader */}
          <div className="absolute left-0 right-0" style={{ top: '45px', height: '60px' }}>
            <div className="absolute inset-x-0 px-4">
              <div className="h-3 bg-neutral-100 rounded w-full mb-2 animate-pulse"></div>
              <div className="h-3 bg-neutral-100 rounded w-2/3 animate-pulse"></div>
            </div>
          </div>
          {/* Basket loader */}
          {topic.basket_id && (
            <div className="absolute bottom-4 left-4">
              <div 
                className="h-3 w-24 rounded animate-pulse"
                style={{ backgroundColor: 'rgb(37 99 235 / 0.2)' }}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default StudyModeItemCard; 